module.exports = __webpack_public_path__ + "static/media/Seam_6750.d1b1be45.jpg";